// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2KDJ-","borderless":"style_borderless__2p36s","transparent":"style_transparent__qTjxn","error":"style_error__y3Xiq","overflow":"style_overflow__2z30m"};